import React from 'react';

type MarqueeSelectionProps = {
  rect: {
    left: number;
    top: number;
    width: number;
    height: number;
  } | null;
};

export const MarqueeSelection: React.FC<MarqueeSelectionProps> = ({ rect }) => {
  if (!rect) return null;

  return (
    <div
      style={{
        position: 'absolute',
        left: `${rect.left}px`,
        top: `${rect.top}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        backgroundColor: 'rgba(24, 144, 255, 0.15)',
        border: '1px dashed #1890ff',
        pointerEvents: 'none',
        zIndex: 1000,
      }}
    />
  );
};

export default MarqueeSelection;
